import {
  expandedNotificationDate,
  expandedNotificationTimeCommon,
  expandedNotificationTimeWrapper,
  notificationDate,
  notificationTimeCommon,
  notificationTimeOS,
} from './styles';
import { OS, PushPreviewType } from '../../common/types';
import { getDate, getTimeSimple } from '../../common/utils';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { NotificationIos } from './NotificationIos';
import { NotificationAndroid } from './NotificationAndroid';
import { ExpandedNotificationIos } from './ExpandedNotificationIos';
import { ExpandedNotificationAndroid } from './ExpandedNotificationAndroid';

type Props = {
  selectedOs: OS;
  selectedPreviewType: PushPreviewType;
};

export const Notification = ({ selectedOs, selectedPreviewType }: Props) => {
  const { locale } = useQueryParamContext();
  // note: this date and time appear in a localized preview, so we specify the locale of the template
  const dateTime = new Date();
  const time = getTimeSimple(dateTime, locale);
  const date = getDate(dateTime, locale);
  const notificationStyle = {
    ...notificationTimeCommon,
    ...notificationTimeOS[selectedOs],
  };
  const expandedNotificationStyle = {
    ...expandedNotificationTimeCommon,
    ...notificationTimeOS[selectedOs],
  };
  const isPreviewTypeNotification = selectedPreviewType === PushPreviewType.notification;
  const wrapperStyle = isPreviewTypeNotification ? {} : expandedNotificationTimeWrapper;
  const timeStyle = isPreviewTypeNotification ? notificationStyle : expandedNotificationStyle;
  const dateStyle = isPreviewTypeNotification ? notificationDate : expandedNotificationDate;

  const renderNotificationPreview = () =>
    selectedOs === OS.ios ? <NotificationIos /> : <NotificationAndroid />;

  const renderExpandedNotificationPreview = () =>
    selectedOs === OS.ios ? <ExpandedNotificationIos /> : <ExpandedNotificationAndroid />;

  return (
    <>
      <div style={wrapperStyle}>
        <div style={timeStyle}>{time}</div>
        <div style={dateStyle}>{date}</div>
      </div>
      {isPreviewTypeNotification
        ? renderNotificationPreview()
        : renderExpandedNotificationPreview()}
    </>
  );
};

export default Notification;
